function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_ddd)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 39,
  y: 31,
  width: 220,
  height: 160,
  rx: 8,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 39,
  y: 31,
  width: 220,
  height: 160,
  rx: 8,
  stroke: "#EAEEF4"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M99.3226 63.5123C97.5322 63.4994 96.2653 62.1431 96.2849 60.2607C96.3046 58.3869 97.562 57.0882 99.3547 57.09C101.164 57.0918 102.41 58.4098 102.401 60.3126C102.393 62.2068 101.124 63.5255 99.3226 63.5123ZM99.3527 54.4549C96.0076 54.443 93.4465 56.9745 93.447 60.2924C93.4475 63.6163 95.9953 66.1442 99.3422 66.1419C102.709 66.1395 105.241 63.633 105.241 60.3035C105.24 56.9597 102.73 54.4669 99.3527 54.4549Z",
  fill: "#2E3545"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.747 60.3466C114.723 62.222 113.461 63.5257 111.671 63.5126C109.881 63.4996 108.614 62.1434 108.634 60.2609C108.653 58.3871 109.911 57.0884 111.703 57.0903C113.5 57.0921 114.738 58.3931 114.747 60.2743C114.747 60.2984 114.747 60.3224 114.747 60.3466ZM114.744 55.2498C113.868 54.7481 112.836 54.459 111.701 54.455C108.356 54.4431 105.795 56.9747 105.796 60.2924C105.796 63.6164 108.344 66.1444 111.691 66.142C112.829 66.1412 113.868 65.8488 114.749 65.3407C114.75 66.1145 114.75 66.603 114.75 66.603C114.741 68.4975 113.473 69.8122 111.671 69.8122C109.358 69.8122 108.341 67.5454 108.341 67.5454L106.221 68.8463C106.221 68.8463 107.439 72.4416 111.691 72.4416C115.058 72.4392 117.59 69.9327 117.589 66.6033V54.4463H114.744C114.744 54.4463 114.744 54.7457 114.744 55.2498Z",
  fill: "#2E3545"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M127.096 60.3472C127.071 62.2223 125.81 63.5256 124.02 63.5125C122.23 63.4996 120.963 62.1434 120.982 60.2609C121.002 58.3871 122.259 57.0884 124.052 57.0903C125.848 57.092 127.086 58.3928 127.096 60.2735C127.096 60.2981 127.096 60.3226 127.096 60.3472ZM127.093 55.2499C126.217 54.7481 125.184 54.459 124.05 54.4551C120.705 54.4431 118.144 56.9747 118.145 60.2925C118.145 63.6164 120.693 66.1444 124.04 66.142C125.178 66.1412 126.216 65.8489 127.098 65.3408C127.098 66.1146 127.099 66.603 127.099 66.603C127.09 68.4975 125.821 69.8123 124.02 69.8123C121.707 69.8123 120.689 67.5454 120.689 67.5454L118.57 68.8464C118.57 68.8464 119.788 72.4417 124.04 72.4417C127.406 72.4393 129.939 69.9328 129.938 66.6034V54.4463H127.093C127.093 54.4463 127.093 54.7457 127.093 55.2499Z",
  fill: "#2E3545"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M131.087 65.9739H134V54.4463H131.087V65.9739Z",
  fill: "#2E3545"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.8393 50.4102H83.9262V65.9736H93.1896V63.1178H86.8393V50.4102Z",
  fill: "#2E3545"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M132.543 53.3337C133.348 53.3337 134 52.6743 134 51.8608C134 51.0473 133.348 50.3879 132.543 50.3879C131.739 50.3879 131.087 51.0473 131.087 51.8608C131.087 52.6743 131.739 53.3337 132.543 53.3337Z",
  fill: "#2E3545"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.0067 52.6094C79.1016 53.2829 80.4298 55.5546 80.4298 55.5546C80.4298 55.5546 81.2604 56.6748 81.2467 56.8192C81.208 57.23 81.0087 57.5936 80.8568 57.8696L80.8442 57.8924C80.674 58.2022 80.0869 59.2703 79.6054 59.5783C79.1113 59.8946 77.1684 60.7749 75.6146 61.2308C75.1899 61.3703 74.3544 61.7115 73.874 62.2522C73.305 62.8927 67.48 68.8254 67.48 68.8254L66.5781 68.5609C66.5781 68.5609 68.0893 66.7723 67.6331 64.5182C67.2679 62.7135 66.296 61.6814 66.296 61.6814C66.296 61.6814 67.8532 64.0505 66.6159 66.7108C66.3385 67.307 65.7957 68.0401 65.1623 68.5836C65.0444 68.6777 64.947 68.7423 64.8767 68.789C64.7255 68.8893 64.6992 68.9068 64.8627 68.9565C65.0033 68.9993 65.1405 69.0406 65.3283 69.0972C65.7351 69.2197 66.3795 69.4138 67.8103 69.849C69.2309 70.2672 69.5722 71.3864 69.5257 71.8397C69.5073 72.0181 69.4153 72.4415 69.4153 72.4415L63.3524 70.5544C63.3524 70.5544 59.2599 69.2615 59.0482 69.2421C58.6925 69.2095 58.0818 68.7684 58.0715 68.2774C58.0694 68.178 58.07 68.0676 58.0707 67.9535C58.0729 67.5657 58.0754 67.1346 57.972 66.9446C57.9122 66.8622 57.7518 66.6924 57.5278 66.4552C56.9679 65.8626 56.0103 64.849 55.2289 63.725C54.2405 62.3032 53.8257 60.7666 54.0672 59.1217C54.4922 56.2269 57.9585 53.8893 60.6872 54.3636C61.2069 54.4539 61.7983 54.585 62.6112 54.7651C64.2393 55.1258 66.756 55.6834 71.3662 56.5054C71.2558 55.3332 71.6422 54.2788 72.2325 53.3719C72.0015 53.0677 71.0168 52.2827 69.1261 52.6434C67.4552 52.9622 66.0982 52.9128 65.271 52.8628C64.1233 52.7934 60.7719 51.6542 59.1441 51.1009C58.7077 50.9526 58.3952 50.8464 58.2822 50.8141C57.5345 50.6009 58.0334 50.1908 58.5665 49.9624C58.8014 49.8618 59.1889 49.6991 59.8172 49.5057C61.3452 50.2287 63.1624 50.9944 64.8581 51.5044C65.7234 51.7646 67.2095 51.8899 69.0583 51.7743C70.9792 51.6542 72.4194 52.0909 72.7977 52.634C72.5899 52.3012 71.5619 51.3894 69.4486 51.4347C67.5966 51.4743 66.1472 51.1754 65.2673 50.9717C64.3481 50.759 62.2332 49.5885 60.5514 48.6178C60.1045 48.3598 59.6882 48.1159 59.333 47.9079C58.7734 47.5801 58.3657 47.3412 58.2296 47.2764C57.5653 46.9601 57.9708 46.787 58.5771 46.64C58.6328 46.6265 58.6999 46.6091 58.7782 46.5889C59.4184 46.4233 60.8104 46.0633 62.9234 46.0033C65.4898 45.9305 68.0229 47.0704 69.7669 47.8552C70.0637 47.9887 70.3377 48.112 70.5851 48.2173C72.2858 48.941 76.1433 51.7313 76.1433 51.7313C76.1433 51.7313 76.2061 51.7786 76.3045 51.8503C76.5907 51.9601 77.3554 52.2634 78.0067 52.6094ZM61.091 71.9439C60.5894 71.647 60.7088 71.0968 61.0535 70.8896C61.2967 70.7739 61.532 70.8739 61.532 70.8739L63.032 71.352C63.032 71.352 61.5363 72.1809 61.091 71.9439Z",
  fill: "#2E3545"
});

var _ref10 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 54,
  y: 46,
  width: 28,
  height: 27
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M78.0067 52.6094C79.1016 53.2829 80.4298 55.5546 80.4298 55.5546C80.4298 55.5546 81.2604 56.6748 81.2467 56.8192C81.208 57.23 81.0087 57.5936 80.8568 57.8696L80.8442 57.8924C80.674 58.2022 80.0869 59.2703 79.6054 59.5783C79.1113 59.8946 77.1684 60.7749 75.6146 61.2308C75.1899 61.3703 74.3544 61.7115 73.874 62.2522C73.305 62.8927 67.48 68.8254 67.48 68.8254L66.5781 68.5609C66.5781 68.5609 68.0893 66.7723 67.6331 64.5182C67.2679 62.7135 66.296 61.6814 66.296 61.6814C66.296 61.6814 67.8532 64.0505 66.6159 66.7108C66.3385 67.307 65.7957 68.0401 65.1623 68.5836C65.0444 68.6777 64.947 68.7423 64.8767 68.789C64.7255 68.8893 64.6992 68.9068 64.8627 68.9565C65.0033 68.9993 65.1405 69.0406 65.3283 69.0972C65.7351 69.2197 66.3795 69.4138 67.8103 69.849C69.2309 70.2672 69.5722 71.3864 69.5257 71.8397C69.5073 72.0181 69.4153 72.4415 69.4153 72.4415L63.3524 70.5544C63.3524 70.5544 59.2599 69.2615 59.0482 69.2421C58.6925 69.2095 58.0818 68.7684 58.0715 68.2774C58.0694 68.178 58.07 68.0676 58.0707 67.9535C58.0729 67.5657 58.0754 67.1346 57.972 66.9446C57.9122 66.8622 57.7518 66.6924 57.5278 66.4552C56.9679 65.8626 56.0103 64.849 55.2289 63.725C54.2405 62.3032 53.8257 60.7666 54.0672 59.1217C54.4922 56.2269 57.9585 53.8893 60.6872 54.3636C61.2069 54.4539 61.7983 54.585 62.6112 54.7651C64.2393 55.1258 66.756 55.6834 71.3662 56.5054C71.2558 55.3332 71.6422 54.2788 72.2325 53.3719C72.0015 53.0677 71.0168 52.2827 69.1261 52.6434C67.4552 52.9622 66.0982 52.9128 65.271 52.8628C64.1233 52.7934 60.7719 51.6542 59.1441 51.1009C58.7077 50.9526 58.3952 50.8464 58.2822 50.8141C57.5345 50.6009 58.0334 50.1908 58.5665 49.9624C58.8014 49.8618 59.1889 49.6991 59.8172 49.5057C61.3452 50.2287 63.1624 50.9944 64.8581 51.5044C65.7234 51.7646 67.2095 51.8899 69.0583 51.7743C70.9792 51.6542 72.4194 52.0909 72.7977 52.634C72.5899 52.3012 71.5619 51.3894 69.4486 51.4347C67.5966 51.4743 66.1472 51.1754 65.2673 50.9717C64.3481 50.759 62.2332 49.5885 60.5514 48.6178C60.1045 48.3598 59.6882 48.1159 59.333 47.9079C58.7734 47.5801 58.3657 47.3412 58.2296 47.2764C57.5653 46.9601 57.9708 46.787 58.5771 46.64C58.6328 46.6265 58.6999 46.6091 58.7782 46.5889C59.4184 46.4233 60.8104 46.0633 62.9234 46.0033C65.4898 45.9305 68.0229 47.0704 69.7669 47.8552C70.0637 47.9887 70.3377 48.112 70.5851 48.2173C72.2858 48.941 76.1433 51.7313 76.1433 51.7313C76.1433 51.7313 76.2061 51.7786 76.3045 51.8503C76.5907 51.9601 77.3554 52.2634 78.0067 52.6094ZM61.091 71.9439C60.5894 71.647 60.7088 71.0968 61.0535 70.8896C61.2967 70.7739 61.532 70.8739 61.532 70.8739L63.032 71.352C63.032 71.352 61.5363 72.1809 61.091 71.9439Z",
  fill: "white"
}));

var _ref11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_b)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 54,
  y: 83,
  width: 67,
  height: 4,
  rx: 2,
  fill: "url(#paint0_linear)"
}));

var _ref13 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_b)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 54,
  y: 91,
  width: 83,
  height: 4,
  rx: 2,
  fill: "url(#paint1_linear)"
}));

var _ref14 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_b)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 65,
  y: 99,
  width: 57,
  height: 4,
  rx: 2,
  fill: "url(#paint2_linear)"
}));

var _ref15 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_b)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 65,
  y: 107,
  width: 66,
  height: 4,
  rx: 2,
  fill: "url(#paint3_linear)"
}));

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 217.077,
  y: 46,
  width: 3.84615,
  height: 3.84615,
  rx: 1.92308,
  fill: "#2E3545"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 217.077,
  y: 52.9231,
  width: 3.84615,
  height: 13.0769,
  rx: 1.92308,
  fill: "#2E3545"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 217.077,
  y: 76,
  width: 3.84615,
  height: 13.0769,
  rx: 1.92308,
  fill: "#2E3545"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 217.077,
  y: 92.1538,
  width: 3.84615,
  height: 3.84615,
  rx: 1.92308,
  fill: "#2E3545"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 217.077,
  y: 69.0769,
  width: 3.84615,
  height: 3.84615,
  rx: 1.92308,
  fill: "#2E3545"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 240.154,
  y: 82.1538,
  width: 3.84615,
  height: 3.84615,
  rx: 1.92308,
  fill: "#2E3545"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 194,
  y: 69.0769,
  width: 3.84615,
  height: 3.84615,
  rx: 1.92308,
  fill: "#2E3545"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 200.923,
  y: 69.0769,
  width: 13.0769,
  height: 3.11355,
  rx: 1.55678,
  fill: "#2E3545"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M224.01 70.8071C224.003 70.8705 224 70.9349 224 71V77.1538C224 78.2159 224.861 79.0769 225.923 79.0769C226.985 79.0769 227.846 78.2159 227.846 77.1538V72.1905H235.52C236.38 72.1905 237.077 71.4935 237.077 70.6337C237.077 69.7739 236.38 69.0769 235.52 69.0769H225.923H225.557C224.697 69.0769 224 69.7739 224 70.6337C224 70.6923 224.003 70.7502 224.01 70.8071Z",
  fill: "#2E3545"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 224,
  y: 82.1538,
  width: 13.0769,
  height: 3.84615,
  rx: 1.92308,
  fill: "#2E3545"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M242.077 69.0769C241.015 69.0769 240.154 69.9379 240.154 71V76H232.48C231.62 76 230.923 76.697 230.923 77.5568C230.923 78.4166 231.62 79.1136 232.48 79.1136H242.443C243.303 79.1136 244 78.4166 244 77.5568C244 77.4922 243.996 77.4285 243.988 77.366C243.996 77.2963 244 77.2255 244 77.1538V71C244 69.9379 243.139 69.0769 242.077 69.0769Z",
  fill: "#2E3545"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M225.923 88.3076C224.861 88.3076 224 89.1686 224 90.2307V94.0768C224 94.1455 224.004 94.2132 224.011 94.28C224.004 94.3395 224 94.4001 224 94.4616C224 95.3112 224.689 96 225.538 96H242.462C243.311 96 244 95.3112 244 94.4616C244 94.4002 243.996 94.3396 243.989 94.2801C243.996 94.2133 244 94.1455 244 94.0768V90.2307C244 89.1686 243.139 88.3076 242.077 88.3076C241.015 88.3076 240.154 89.1686 240.154 90.2307V92.9231H237.846V90.3076C237.846 89.203 236.951 88.3076 235.846 88.3076H232.923C231.819 88.3076 230.923 89.203 230.923 90.3076V92.9231H227.846V90.2307C227.846 89.1686 226.985 88.3076 225.923 88.3076Z",
  fill: "#2E3545"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M224 48C224 46.8954 224.895 46 226 46H242C243.105 46 244 46.8954 244 48V64C244 65.1046 243.105 66 242 66H226C224.895 66 224 65.1046 224 64V48ZM228 51C228 50.4477 228.448 50 229 50H239C239.552 50 240 50.4477 240 51V61C240 61.5523 239.552 62 239 62H229C228.448 62 228 61.5523 228 61V51ZM232 53C231.448 53 231 53.4477 231 54V58.1538C231 58.7061 231.448 59.1538 232 59.1538H236.154C236.706 59.1538 237.154 58.7061 237.154 58.1538V54C237.154 53.4477 236.706 53 236.154 53H232Z",
  fill: "#2E3545"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194 48C194 46.8954 194.895 46 196 46H212C213.105 46 214 46.8954 214 48V64C214 65.1046 213.105 66 212 66H196C194.895 66 194 65.1046 194 64V48ZM198 51C198 50.4477 198.448 50 199 50H209C209.552 50 210 50.4477 210 51V61C210 61.5523 209.552 62 209 62H199C198.448 62 198 61.5523 198 61V51ZM202 53C201.448 53 201 53.4477 201 54V58.1538C201 58.7061 201.448 59.1538 202 59.1538H206.154C206.706 59.1538 207.154 58.7061 207.154 58.1538V54C207.154 53.4477 206.706 53 206.154 53H202Z",
  fill: "#2E3545"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194 78C194 76.8954 194.895 76 196 76H212C213.105 76 214 76.8954 214 78V94C214 95.1046 213.105 96 212 96H196C194.895 96 194 95.1046 194 94V78ZM198 81C198 80.4477 198.448 80 199 80H209C209.552 80 210 80.4477 210 81V91C210 91.5523 209.552 92 209 92H199C198.448 92 198 91.5523 198 91V81ZM202 83C201.448 83 201 83.4477 201 84V88.1538C201 88.7061 201.448 89.1538 202 89.1538H206.154C206.706 89.1538 207.154 88.7061 207.154 88.1538V84C207.154 83.4477 206.706 83 206.154 83H202Z",
  fill: "#2E3545"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M178.409 107V102.241H179.418V106.167H181.348V107H178.409Z",
  fill: "#2E3545"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M183.985 104.327H185.873V106.795C185.567 106.895 185.278 106.964 185.007 107.003C184.738 107.044 184.462 107.065 184.18 107.065C183.462 107.065 182.913 106.855 182.533 106.434C182.155 106.01 181.967 105.404 181.967 104.614C181.967 103.846 182.186 103.247 182.624 102.817C183.065 102.387 183.674 102.173 184.453 102.173C184.942 102.173 185.413 102.27 185.866 102.465L185.531 103.273C185.184 103.099 184.822 103.012 184.447 103.012C184.011 103.012 183.661 103.159 183.399 103.452C183.136 103.745 183.005 104.139 183.005 104.633C183.005 105.15 183.11 105.545 183.321 105.818C183.533 106.09 183.842 106.225 184.245 106.225C184.456 106.225 184.669 106.204 184.886 106.16V105.167H183.985V104.327Z",
  fill: "#2E3545"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M189.164 107H188.158V104.246L188.168 103.794L188.184 103.299C188.017 103.466 187.901 103.576 187.836 103.628L187.289 104.067L186.804 103.462L188.337 102.241H189.164V107Z",
  fill: "#2E3545"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M193.812 107H190.485V106.3L191.68 105.092C192.034 104.73 192.265 104.479 192.373 104.34C192.482 104.199 192.56 104.069 192.608 103.95C192.656 103.831 192.679 103.707 192.679 103.579C192.679 103.388 192.626 103.246 192.52 103.152C192.416 103.059 192.276 103.012 192.1 103.012C191.916 103.012 191.736 103.055 191.563 103.139C191.389 103.224 191.208 103.344 191.019 103.501L190.472 102.853C190.707 102.653 190.901 102.512 191.055 102.43C191.209 102.347 191.377 102.284 191.56 102.241C191.742 102.195 191.946 102.173 192.172 102.173C192.469 102.173 192.731 102.227 192.959 102.335C193.187 102.444 193.364 102.596 193.49 102.791C193.616 102.986 193.679 103.21 193.679 103.462C193.679 103.681 193.64 103.887 193.562 104.08C193.486 104.271 193.366 104.467 193.203 104.669C193.043 104.871 192.759 105.159 192.351 105.532L191.739 106.108V106.154H193.812V107Z",
  fill: "#2E3545"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M197.595 104.62C197.595 105.452 197.458 106.067 197.185 106.466C196.913 106.865 196.495 107.065 195.928 107.065C195.379 107.065 194.965 106.859 194.685 106.447C194.407 106.034 194.268 105.426 194.268 104.62C194.268 103.781 194.404 103.162 194.675 102.765C194.946 102.366 195.364 102.166 195.928 102.166C196.477 102.166 196.892 102.374 197.172 102.791C197.454 103.208 197.595 103.817 197.595 104.62ZM195.267 104.62C195.267 105.204 195.317 105.623 195.417 105.877C195.519 106.129 195.689 106.255 195.928 106.255C196.162 106.255 196.332 106.127 196.436 105.87C196.54 105.614 196.592 105.198 196.592 104.62C196.592 104.037 196.539 103.618 196.433 103.364C196.328 103.108 196.16 102.98 195.928 102.98C195.692 102.98 195.522 103.108 195.42 103.364C195.318 103.618 195.267 104.037 195.267 104.62Z",
  fill: "#2E3545"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M201.244 103.305C201.244 103.603 201.154 103.855 200.974 104.064C200.794 104.272 200.541 104.415 200.215 104.493V104.513C200.599 104.561 200.89 104.678 201.088 104.865C201.285 105.049 201.384 105.299 201.384 105.613C201.384 106.071 201.218 106.428 200.886 106.684C200.554 106.938 200.08 107.065 199.463 107.065C198.947 107.065 198.489 106.979 198.09 106.808V105.952C198.274 106.045 198.477 106.121 198.698 106.18C198.92 106.238 199.139 106.268 199.356 106.268C199.688 106.268 199.933 106.211 200.092 106.098C200.25 105.985 200.329 105.804 200.329 105.555C200.329 105.331 200.238 105.173 200.056 105.079C199.873 104.986 199.583 104.939 199.183 104.939H198.822V104.168H199.19C199.559 104.168 199.828 104.12 199.997 104.025C200.169 103.927 200.254 103.761 200.254 103.527C200.254 103.166 200.029 102.986 199.577 102.986C199.421 102.986 199.261 103.012 199.099 103.064C198.938 103.117 198.759 103.207 198.562 103.335L198.096 102.641C198.53 102.329 199.048 102.173 199.649 102.173C200.141 102.173 200.53 102.272 200.814 102.472C201.101 102.672 201.244 102.949 201.244 103.305Z",
  fill: "#2E3545"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M205.238 107H201.911V106.3L203.106 105.092C203.46 104.73 203.691 104.479 203.799 104.34C203.908 104.199 203.986 104.069 204.034 103.95C204.081 103.831 204.105 103.707 204.105 103.579C204.105 103.388 204.052 103.246 203.946 103.152C203.842 103.059 203.702 103.012 203.526 103.012C203.341 103.012 203.162 103.055 202.989 103.139C202.815 103.224 202.634 103.344 202.445 103.501L201.898 102.853C202.133 102.653 202.327 102.512 202.481 102.43C202.635 102.347 202.803 102.284 202.985 102.241C203.168 102.195 203.372 102.173 203.597 102.173C203.895 102.173 204.157 102.227 204.385 102.335C204.613 102.444 204.79 102.596 204.916 102.791C205.042 102.986 205.105 103.21 205.105 103.462C205.105 103.681 205.065 103.887 204.987 104.08C204.911 104.271 204.792 104.467 204.629 104.669C204.469 104.871 204.184 105.159 203.776 105.532L203.164 106.108V106.154H205.238V107Z",
  fill: "#2E3545"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M208.207 107H207.201V104.246L207.211 103.794L207.227 103.299C207.06 103.466 206.944 103.576 206.879 103.628L206.332 104.067L205.847 103.462L207.38 102.241H208.207V107Z",
  fill: "#2E3545"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M212.67 103.305C212.67 103.603 212.58 103.855 212.399 104.064C212.219 104.272 211.967 104.415 211.641 104.493V104.513C212.025 104.561 212.316 104.678 212.513 104.865C212.711 105.049 212.81 105.299 212.81 105.613C212.81 106.071 212.644 106.428 212.312 106.684C211.98 106.938 211.505 107.065 210.889 107.065C210.373 107.065 209.915 106.979 209.515 106.808V105.952C209.7 106.045 209.903 106.121 210.124 106.18C210.345 106.238 210.565 106.268 210.782 106.268C211.114 106.268 211.359 106.211 211.517 106.098C211.676 105.985 211.755 105.804 211.755 105.555C211.755 105.331 211.664 105.173 211.481 105.079C211.299 104.986 211.008 104.939 210.609 104.939H210.248V104.168H210.616C210.985 104.168 211.254 104.12 211.423 104.025C211.594 103.927 211.68 103.761 211.68 103.527C211.68 103.166 211.454 102.986 211.003 102.986C210.847 102.986 210.687 103.012 210.524 103.064C210.364 103.117 210.185 103.207 209.987 103.335L209.522 102.641C209.956 102.329 210.473 102.173 211.075 102.173C211.567 102.173 211.956 102.272 212.24 102.472C212.526 102.672 212.67 102.949 212.67 103.305Z",
  fill: "#2E3545"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M214.978 102.179C215.433 102.179 215.8 102.283 216.078 102.492C216.358 102.698 216.498 102.977 216.498 103.328C216.498 103.571 216.43 103.788 216.296 103.979C216.161 104.168 215.944 104.337 215.645 104.487C216.001 104.678 216.256 104.878 216.41 105.086C216.566 105.292 216.644 105.519 216.644 105.766C216.644 106.157 216.491 106.472 216.185 106.71C215.879 106.947 215.477 107.065 214.978 107.065C214.457 107.065 214.048 106.954 213.75 106.733C213.453 106.512 213.304 106.198 213.304 105.792C213.304 105.521 213.376 105.28 213.519 105.07C213.665 104.859 213.897 104.674 214.216 104.513C213.945 104.342 213.749 104.158 213.63 103.963C213.511 103.768 213.451 103.554 213.451 103.322C213.451 102.981 213.592 102.705 213.874 102.495C214.156 102.284 214.524 102.179 214.978 102.179ZM214.235 105.734C214.235 105.92 214.3 106.066 214.431 106.17C214.561 106.274 214.739 106.326 214.965 106.326C215.214 106.326 215.401 106.273 215.524 106.167C215.648 106.058 215.71 105.916 215.71 105.74C215.71 105.595 215.648 105.459 215.524 105.333C215.403 105.205 215.204 105.07 214.929 104.926C214.467 105.139 214.235 105.408 214.235 105.734ZM214.971 102.915C214.8 102.915 214.661 102.959 214.554 103.048C214.45 103.135 214.398 103.252 214.398 103.4C214.398 103.53 214.439 103.647 214.522 103.751C214.606 103.853 214.758 103.959 214.978 104.067C215.19 103.967 215.339 103.865 215.424 103.761C215.508 103.657 215.55 103.536 215.55 103.4C215.55 103.25 215.496 103.132 215.388 103.045C215.279 102.958 215.14 102.915 214.971 102.915Z",
  fill: "#2E3545"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M220.472 107H217.146V106.3L218.34 105.092C218.694 104.73 218.925 104.479 219.034 104.34C219.142 104.199 219.22 104.069 219.268 103.95C219.316 103.831 219.34 103.707 219.34 103.579C219.34 103.388 219.286 103.246 219.18 103.152C219.076 103.059 218.936 103.012 218.76 103.012C218.576 103.012 218.397 103.055 218.223 103.139C218.049 103.224 217.868 103.344 217.679 103.501L217.133 102.853C217.367 102.653 217.561 102.512 217.715 102.43C217.869 102.347 218.037 102.284 218.22 102.241C218.402 102.195 218.606 102.173 218.832 102.173C219.129 102.173 219.392 102.227 219.62 102.335C219.847 102.444 220.024 102.596 220.15 102.791C220.276 102.986 220.339 103.21 220.339 103.462C220.339 103.681 220.3 103.887 220.222 104.08C220.146 104.271 220.026 104.467 219.864 104.669C219.703 104.871 219.419 105.159 219.011 105.532L218.399 106.108V106.154H220.472V107Z",
  fill: "#2E3545"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M223.441 107H222.435V104.246L222.445 103.794L222.461 103.299C222.294 103.466 222.178 103.576 222.113 103.628L221.566 104.067L221.081 103.462L222.614 102.241H223.441V107Z",
  fill: "#2E3545"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M227.904 103.305C227.904 103.603 227.814 103.855 227.634 104.064C227.454 104.272 227.201 104.415 226.875 104.493V104.513C227.259 104.561 227.55 104.678 227.748 104.865C227.945 105.049 228.044 105.299 228.044 105.613C228.044 106.071 227.878 106.428 227.546 106.684C227.214 106.938 226.74 107.065 226.123 107.065C225.607 107.065 225.149 106.979 224.75 106.808V105.952C224.934 106.045 225.137 106.121 225.358 106.18C225.58 106.238 225.799 106.268 226.016 106.268C226.348 106.268 226.593 106.211 226.752 106.098C226.91 105.985 226.989 105.804 226.989 105.555C226.989 105.331 226.898 105.173 226.716 105.079C226.534 104.986 226.243 104.939 225.843 104.939H225.482V104.168H225.85C226.219 104.168 226.488 104.12 226.657 104.025C226.829 103.927 226.914 103.761 226.914 103.527C226.914 103.166 226.689 102.986 226.237 102.986C226.081 102.986 225.922 103.012 225.759 103.064C225.598 103.117 225.419 103.207 225.222 103.335L224.756 102.641C225.19 102.329 225.708 102.173 226.309 102.173C226.802 102.173 227.19 102.272 227.474 102.472C227.761 102.672 227.904 102.949 227.904 103.305Z",
  fill: "#2E3545"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M231.713 103.305C231.713 103.603 231.623 103.855 231.442 104.064C231.262 104.272 231.009 104.415 230.684 104.493V104.513C231.068 104.561 231.359 104.678 231.556 104.865C231.754 105.049 231.853 105.299 231.853 105.613C231.853 106.071 231.687 106.428 231.355 106.684C231.023 106.938 230.548 107.065 229.932 107.065C229.416 107.065 228.958 106.979 228.558 106.808V105.952C228.743 106.045 228.946 106.121 229.167 106.18C229.388 106.238 229.608 106.268 229.825 106.268C230.157 106.268 230.402 106.211 230.56 106.098C230.719 105.985 230.798 105.804 230.798 105.555C230.798 105.331 230.707 105.173 230.524 105.079C230.342 104.986 230.051 104.939 229.652 104.939H229.291V104.168H229.659C230.027 104.168 230.297 104.12 230.466 104.025C230.637 103.927 230.723 103.761 230.723 103.527C230.723 103.166 230.497 102.986 230.046 102.986C229.89 102.986 229.73 103.012 229.567 103.064C229.407 103.117 229.228 103.207 229.03 103.335L228.565 102.641C228.999 102.329 229.516 102.173 230.118 102.173C230.61 102.173 230.999 102.272 231.283 102.472C231.569 102.672 231.713 102.949 231.713 103.305Z",
  fill: "#2E3545"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M234.867 107H233.861V104.246L233.871 103.794L233.887 103.299C233.72 103.466 233.604 103.576 233.539 103.628L232.992 104.067L232.507 103.462L234.04 102.241H234.867V107Z",
  fill: "#2E3545"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M239.515 107H236.189V106.3L237.383 105.092C237.737 104.73 237.968 104.479 238.077 104.34C238.185 104.199 238.263 104.069 238.311 103.95C238.359 103.831 238.383 103.707 238.383 103.579C238.383 103.388 238.329 103.246 238.223 103.152C238.119 103.059 237.979 103.012 237.803 103.012C237.619 103.012 237.44 103.055 237.266 103.139C237.092 103.224 236.911 103.344 236.722 103.501L236.175 102.853C236.41 102.653 236.604 102.512 236.758 102.43C236.912 102.347 237.08 102.284 237.263 102.241C237.445 102.195 237.649 102.173 237.875 102.173C238.172 102.173 238.435 102.227 238.662 102.335C238.89 102.444 239.067 102.596 239.193 102.791C239.319 102.986 239.382 103.21 239.382 103.462C239.382 103.681 239.343 103.887 239.265 104.08C239.189 104.271 239.069 104.467 238.907 104.669C238.746 104.871 238.462 105.159 238.054 105.532L237.442 106.108V106.154H239.515V107Z",
  fill: "#2E3545"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M243.138 103.305C243.138 103.603 243.048 103.855 242.868 104.064C242.688 104.272 242.435 104.415 242.11 104.493V104.513C242.494 104.561 242.785 104.678 242.982 104.865C243.18 105.049 243.278 105.299 243.278 105.613C243.278 106.071 243.112 106.428 242.78 106.684C242.448 106.938 241.974 107.065 241.358 107.065C240.841 107.065 240.383 106.979 239.984 106.808V105.952C240.169 106.045 240.371 106.121 240.593 106.18C240.814 106.238 241.033 106.268 241.25 106.268C241.582 106.268 241.828 106.211 241.986 106.098C242.144 105.985 242.224 105.804 242.224 105.555C242.224 105.331 242.133 105.173 241.95 105.079C241.768 104.986 241.477 104.939 241.078 104.939H240.717V104.168H241.084C241.453 104.168 241.722 104.12 241.892 104.025C242.063 103.927 242.149 103.761 242.149 103.527C242.149 103.166 241.923 102.986 241.472 102.986C241.315 102.986 241.156 103.012 240.993 103.064C240.833 103.117 240.654 103.207 240.456 103.335L239.991 102.641C240.425 102.329 240.942 102.173 241.543 102.173C242.036 102.173 242.424 102.272 242.709 102.472C242.995 102.672 243.138 102.949 243.138 103.305Z",
  fill: "#2E3545"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M116.599 136V131.241H117.608V135.167H119.538V136H116.599Z",
  fill: "#2E3545"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M122.175 133.327H124.063V135.795C123.757 135.895 123.469 135.964 123.197 136.003C122.928 136.044 122.653 136.065 122.37 136.065C121.652 136.065 121.103 135.855 120.723 135.434C120.346 135.01 120.157 134.404 120.157 133.614C120.157 132.846 120.376 132.247 120.814 131.817C121.255 131.387 121.865 131.173 122.644 131.173C123.132 131.173 123.603 131.27 124.057 131.465L123.721 132.273C123.374 132.099 123.013 132.012 122.637 132.012C122.201 132.012 121.852 132.159 121.589 132.452C121.327 132.745 121.195 133.139 121.195 133.633C121.195 134.15 121.301 134.545 121.511 134.818C121.724 135.09 122.032 135.225 122.436 135.225C122.646 135.225 122.86 135.204 123.077 135.16V134.167H122.175V133.327Z",
  fill: "#2E3545"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M127.354 136H126.348V133.246L126.358 132.794L126.374 132.299C126.207 132.466 126.091 132.576 126.026 132.628L125.479 133.067L124.994 132.462L126.527 131.241H127.354V136Z",
  fill: "#2E3545"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M132.003 136H128.676V135.3L129.87 134.092C130.224 133.73 130.455 133.479 130.564 133.34C130.672 133.199 130.75 133.069 130.798 132.95C130.846 132.831 130.87 132.707 130.87 132.579C130.87 132.388 130.817 132.246 130.71 132.152C130.606 132.059 130.466 132.012 130.29 132.012C130.106 132.012 129.927 132.055 129.753 132.139C129.58 132.224 129.398 132.344 129.21 132.501L128.663 131.853C128.897 131.653 129.091 131.512 129.245 131.43C129.4 131.347 129.568 131.284 129.75 131.241C129.932 131.195 130.136 131.173 130.362 131.173C130.659 131.173 130.922 131.227 131.15 131.335C131.378 131.444 131.555 131.596 131.68 131.791C131.806 131.986 131.869 132.21 131.869 132.462C131.869 132.681 131.83 132.887 131.752 133.08C131.676 133.271 131.557 133.467 131.394 133.669C131.233 133.871 130.949 134.159 130.541 134.532L129.929 135.108V135.154H132.003V136Z",
  fill: "#2E3545"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M135.785 133.62C135.785 134.452 135.648 135.067 135.375 135.466C135.104 135.865 134.685 136.065 134.119 136.065C133.569 136.065 133.155 135.859 132.875 135.447C132.597 135.034 132.458 134.426 132.458 133.62C132.458 132.781 132.594 132.162 132.865 131.765C133.137 131.366 133.554 131.166 134.119 131.166C134.668 131.166 135.082 131.374 135.362 131.791C135.644 132.208 135.785 132.817 135.785 133.62ZM133.458 133.62C133.458 134.204 133.508 134.623 133.607 134.877C133.709 135.129 133.88 135.255 134.119 135.255C134.353 135.255 134.522 135.127 134.626 134.87C134.731 134.614 134.783 134.198 134.783 133.62C134.783 133.037 134.729 132.618 134.623 132.364C134.519 132.108 134.351 131.98 134.119 131.98C133.882 131.98 133.713 132.108 133.611 132.364C133.509 132.618 133.458 133.037 133.458 133.62Z",
  fill: "#2E3545"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M139.434 132.305C139.434 132.603 139.344 132.855 139.164 133.064C138.984 133.272 138.731 133.415 138.406 133.493V133.513C138.79 133.561 139.081 133.678 139.278 133.865C139.476 134.049 139.574 134.299 139.574 134.613C139.574 135.071 139.408 135.428 139.076 135.684C138.744 135.938 138.27 136.065 137.654 136.065C137.137 136.065 136.679 135.979 136.28 135.808V134.952C136.464 135.045 136.667 135.121 136.889 135.18C137.11 135.238 137.329 135.268 137.546 135.268C137.878 135.268 138.124 135.211 138.282 135.098C138.44 134.985 138.52 134.804 138.52 134.555C138.52 134.331 138.428 134.173 138.246 134.079C138.064 133.986 137.773 133.939 137.374 133.939H137.012V133.168H137.38C137.749 133.168 138.018 133.12 138.188 133.025C138.359 132.927 138.445 132.761 138.445 132.527C138.445 132.166 138.219 131.986 137.768 131.986C137.611 131.986 137.452 132.012 137.289 132.064C137.129 132.117 136.949 132.207 136.752 132.335L136.286 131.641C136.721 131.329 137.238 131.173 137.839 131.173C138.332 131.173 138.72 131.272 139.005 131.472C139.291 131.672 139.434 131.949 139.434 132.305Z",
  fill: "#2E3545"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M143.428 136H140.102V135.3L141.296 134.092C141.65 133.73 141.881 133.479 141.99 133.34C142.098 133.199 142.176 133.069 142.224 132.95C142.272 132.831 142.296 132.707 142.296 132.579C142.296 132.388 142.242 132.246 142.136 132.152C142.032 132.059 141.892 132.012 141.716 132.012C141.532 132.012 141.353 132.055 141.179 132.139C141.005 132.224 140.824 132.344 140.635 132.501L140.089 131.853C140.323 131.653 140.517 131.512 140.671 131.43C140.825 131.347 140.994 131.284 141.176 131.241C141.358 131.195 141.562 131.173 141.788 131.173C142.085 131.173 142.348 131.227 142.576 131.335C142.803 131.444 142.98 131.596 143.106 131.791C143.232 131.986 143.295 132.21 143.295 132.462C143.295 132.681 143.256 132.887 143.178 133.08C143.102 133.271 142.982 133.467 142.82 133.669C142.659 133.871 142.375 134.159 141.967 134.532L141.355 135.108V135.154H143.428V136Z",
  fill: "#2E3545"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M146.397 136H145.391V133.246L145.401 132.794L145.417 132.299C145.25 132.466 145.134 132.576 145.069 132.628L144.522 133.067L144.037 132.462L145.57 131.241H146.397V136Z",
  fill: "#2E3545"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M150.86 132.305C150.86 132.603 150.77 132.855 150.59 133.064C150.41 133.272 150.157 133.415 149.831 133.493V133.513C150.216 133.561 150.506 133.678 150.704 133.865C150.901 134.049 151 134.299 151 134.613C151 135.071 150.834 135.428 150.502 135.684C150.17 135.938 149.696 136.065 149.079 136.065C148.563 136.065 148.105 135.979 147.706 135.808V134.952C147.89 135.045 148.093 135.121 148.314 135.18C148.536 135.238 148.755 135.268 148.972 135.268C149.304 135.268 149.549 135.211 149.708 135.098C149.866 134.985 149.945 134.804 149.945 134.555C149.945 134.331 149.854 134.173 149.672 134.079C149.49 133.986 149.199 133.939 148.8 133.939H148.438V133.168H148.806C149.175 133.168 149.444 133.12 149.613 133.025C149.785 132.927 149.87 132.761 149.87 132.527C149.87 132.166 149.645 131.986 149.193 131.986C149.037 131.986 148.878 132.012 148.715 132.064C148.554 132.117 148.375 132.207 148.178 132.335L147.712 131.641C148.146 131.329 148.664 131.173 149.265 131.173C149.758 131.173 150.146 131.272 150.43 131.472C150.717 131.672 150.86 131.949 150.86 132.305Z",
  fill: "#2E3545"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M153.168 131.179C153.624 131.179 153.99 131.283 154.268 131.492C154.548 131.698 154.688 131.977 154.688 132.328C154.688 132.571 154.621 132.788 154.486 132.979C154.352 133.168 154.135 133.337 153.835 133.487C154.191 133.678 154.446 133.878 154.6 134.086C154.757 134.292 154.835 134.519 154.835 134.766C154.835 135.157 154.682 135.472 154.376 135.71C154.07 135.947 153.667 136.065 153.168 136.065C152.647 136.065 152.238 135.954 151.941 135.733C151.643 135.512 151.495 135.198 151.495 134.792C151.495 134.521 151.566 134.28 151.71 134.07C151.855 133.859 152.087 133.674 152.406 133.513C152.135 133.342 151.94 133.158 151.82 132.963C151.701 132.768 151.641 132.554 151.641 132.322C151.641 131.981 151.782 131.705 152.064 131.495C152.347 131.284 152.714 131.179 153.168 131.179ZM152.426 134.734C152.426 134.92 152.491 135.066 152.621 135.17C152.751 135.274 152.929 135.326 153.155 135.326C153.405 135.326 153.591 135.273 153.715 135.167C153.839 135.058 153.9 134.916 153.9 134.74C153.9 134.595 153.839 134.459 153.715 134.333C153.593 134.205 153.395 134.07 153.119 133.926C152.657 134.139 152.426 134.408 152.426 134.734ZM153.162 131.915C152.99 131.915 152.851 131.959 152.745 132.048C152.641 132.135 152.589 132.252 152.589 132.4C152.589 132.53 152.63 132.647 152.712 132.751C152.797 132.853 152.949 132.959 153.168 133.067C153.381 132.967 153.529 132.865 153.614 132.761C153.699 132.657 153.741 132.536 153.741 132.4C153.741 132.25 153.687 132.132 153.578 132.045C153.47 131.958 153.331 131.915 153.162 131.915Z",
  fill: "#2E3545"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M158.663 136H155.336V135.3L156.531 134.092C156.884 133.73 157.115 133.479 157.224 133.34C157.333 133.199 157.411 133.069 157.458 132.95C157.506 132.831 157.53 132.707 157.53 132.579C157.53 132.388 157.477 132.246 157.37 132.152C157.266 132.059 157.126 132.012 156.951 132.012C156.766 132.012 156.587 132.055 156.413 132.139C156.24 132.224 156.059 132.344 155.87 132.501L155.323 131.853C155.557 131.653 155.752 131.512 155.906 131.43C156.06 131.347 156.228 131.284 156.41 131.241C156.592 131.195 156.796 131.173 157.022 131.173C157.319 131.173 157.582 131.227 157.81 131.335C158.038 131.444 158.215 131.596 158.341 131.791C158.466 131.986 158.529 132.21 158.529 132.462C158.529 132.681 158.49 132.887 158.412 133.08C158.336 133.271 158.217 133.467 158.054 133.669C157.893 133.871 157.609 134.159 157.201 134.532L156.589 135.108V135.154H158.663V136Z",
  fill: "#2E3545"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M161.632 136H160.626V133.246L160.635 132.794L160.652 132.299C160.485 132.466 160.369 132.576 160.303 132.628L159.757 133.067L159.272 132.462L160.805 131.241H161.632V136Z",
  fill: "#2E3545"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M166.094 132.305C166.094 132.603 166.004 132.855 165.824 133.064C165.644 133.272 165.391 133.415 165.066 133.493V133.513C165.45 133.561 165.741 133.678 165.938 133.865C166.136 134.049 166.234 134.299 166.234 134.613C166.234 135.071 166.068 135.428 165.736 135.684C165.404 135.938 164.93 136.065 164.314 136.065C163.797 136.065 163.339 135.979 162.94 135.808V134.952C163.125 135.045 163.328 135.121 163.549 135.18C163.77 135.238 163.989 135.268 164.206 135.268C164.538 135.268 164.784 135.211 164.942 135.098C165.101 134.985 165.18 134.804 165.18 134.555C165.18 134.331 165.089 134.173 164.906 134.079C164.724 133.986 164.433 133.939 164.034 133.939H163.673V133.168H164.04C164.409 133.168 164.678 133.12 164.848 133.025C165.019 132.927 165.105 132.761 165.105 132.527C165.105 132.166 164.879 131.986 164.428 131.986C164.272 131.986 164.112 132.012 163.949 132.064C163.789 132.117 163.61 132.207 163.412 132.335L162.947 131.641C163.381 131.329 163.898 131.173 164.499 131.173C164.992 131.173 165.38 131.272 165.665 131.472C165.951 131.672 166.094 131.949 166.094 132.305Z",
  fill: "#2E3545"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M169.903 132.305C169.903 132.603 169.813 132.855 169.633 133.064C169.453 133.272 169.2 133.415 168.874 133.493V133.513C169.259 133.561 169.549 133.678 169.747 133.865C169.944 134.049 170.043 134.299 170.043 134.613C170.043 135.071 169.877 135.428 169.545 135.684C169.213 135.938 168.739 136.065 168.122 136.065C167.606 136.065 167.148 135.979 166.749 135.808V134.952C166.933 135.045 167.136 135.121 167.357 135.18C167.579 135.238 167.798 135.268 168.015 135.268C168.347 135.268 168.592 135.211 168.751 135.098C168.909 134.985 168.988 134.804 168.988 134.555C168.988 134.331 168.897 134.173 168.715 134.079C168.533 133.986 168.242 133.939 167.842 133.939H167.481V133.168H167.849C168.218 133.168 168.487 133.12 168.656 133.025C168.828 132.927 168.913 132.761 168.913 132.527C168.913 132.166 168.688 131.986 168.236 131.986C168.08 131.986 167.921 132.012 167.758 132.064C167.597 132.117 167.418 132.207 167.221 132.335L166.755 131.641C167.189 131.329 167.707 131.173 168.308 131.173C168.801 131.173 169.189 131.272 169.473 131.472C169.76 131.672 169.903 131.949 169.903 132.305Z",
  fill: "#2E3545"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M173.057 136H172.051V133.246L172.061 132.794L172.078 132.299C171.91 132.466 171.794 132.576 171.729 132.628L171.182 133.067L170.697 132.462L172.231 131.241H173.057V136Z",
  fill: "#2E3545"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M177.706 136H174.379V135.3L175.574 134.092C175.927 133.73 176.158 133.479 176.267 133.34C176.375 133.199 176.454 133.069 176.501 132.95C176.549 132.831 176.573 132.707 176.573 132.579C176.573 132.388 176.52 132.246 176.413 132.152C176.309 132.059 176.169 132.012 175.994 132.012C175.809 132.012 175.63 132.055 175.456 132.139C175.283 132.224 175.102 132.344 174.913 132.501L174.366 131.853C174.6 131.653 174.795 131.512 174.949 131.43C175.103 131.347 175.271 131.284 175.453 131.241C175.635 131.195 175.839 131.173 176.065 131.173C176.362 131.173 176.625 131.227 176.853 131.335C177.081 131.444 177.258 131.596 177.384 131.791C177.509 131.986 177.572 132.21 177.572 132.462C177.572 132.681 177.533 132.887 177.455 133.08C177.379 133.271 177.26 133.467 177.097 133.669C176.936 133.871 176.652 134.159 176.244 134.532L175.632 135.108V135.154H177.706V136Z",
  fill: "#2E3545"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M181.329 132.305C181.329 132.603 181.239 132.855 181.059 133.064C180.879 133.272 180.626 133.415 180.3 133.493V133.513C180.684 133.561 180.975 133.678 181.173 133.865C181.37 134.049 181.469 134.299 181.469 134.613C181.469 135.071 181.303 135.428 180.971 135.684C180.639 135.938 180.165 136.065 179.548 136.065C179.032 136.065 178.574 135.979 178.175 135.808V134.952C178.359 135.045 178.562 135.121 178.783 135.18C179.005 135.238 179.224 135.268 179.441 135.268C179.773 135.268 180.018 135.211 180.176 135.098C180.335 134.985 180.414 134.804 180.414 134.555C180.414 134.331 180.323 134.173 180.141 134.079C179.958 133.986 179.668 133.939 179.268 133.939H178.907V133.168H179.275C179.644 133.168 179.913 133.12 180.082 133.025C180.254 132.927 180.339 132.761 180.339 132.527C180.339 132.166 180.114 131.986 179.662 131.986C179.506 131.986 179.346 132.012 179.184 132.064C179.023 132.117 178.844 132.207 178.647 132.335L178.181 131.641C178.615 131.329 179.133 131.173 179.734 131.173C180.226 131.173 180.615 131.272 180.899 131.472C181.186 131.672 181.329 131.949 181.329 132.305Z",
  fill: "#2E3545"
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  x: 56,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref66 = /*#__PURE__*/React.createElement("rect", {
  x: 178.986,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  x: 66.0823,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref68 = /*#__PURE__*/React.createElement("rect", {
  x: 189.068,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref69 = /*#__PURE__*/React.createElement("rect", {
  x: 78.6849,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref70 = /*#__PURE__*/React.createElement("rect", {
  x: 201.671,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref71 = /*#__PURE__*/React.createElement("rect", {
  x: 105.151,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref72 = /*#__PURE__*/React.createElement("rect", {
  x: 228.137,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref73 = /*#__PURE__*/React.createElement("rect", {
  x: 163.123,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref74 = /*#__PURE__*/React.createElement("rect", {
  x: 110.192,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref75 = /*#__PURE__*/React.createElement("rect", {
  x: 233.178,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref76 = /*#__PURE__*/React.createElement("rect", {
  x: 168.165,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref77 = /*#__PURE__*/React.createElement("rect", {
  x: 121.534,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref78 = /*#__PURE__*/React.createElement("rect", {
  x: 83.726,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref79 = /*#__PURE__*/React.createElement("rect", {
  x: 206.712,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref80 = /*#__PURE__*/React.createElement("rect", {
  x: 126.576,
  y: 142,
  width: 3.78125,
  height: 34,
  rx: 1.89062,
  fill: "#2E3545"
});

var _ref81 = /*#__PURE__*/React.createElement("rect", {
  x: 62.3021,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref82 = /*#__PURE__*/React.createElement("rect", {
  x: 185.288,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref83 = /*#__PURE__*/React.createElement("rect", {
  x: 71.1233,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref84 = /*#__PURE__*/React.createElement("rect", {
  x: 194.11,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref85 = /*#__PURE__*/React.createElement("rect", {
  x: 88.7672,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref86 = /*#__PURE__*/React.createElement("rect", {
  x: 211.753,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref87 = /*#__PURE__*/React.createElement("rect", {
  x: 146.74,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref88 = /*#__PURE__*/React.createElement("rect", {
  x: 131.617,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref89 = /*#__PURE__*/React.createElement("rect", {
  x: 91.2877,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref90 = /*#__PURE__*/React.createElement("rect", {
  x: 214.274,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref91 = /*#__PURE__*/React.createElement("rect", {
  x: 149.26,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref92 = /*#__PURE__*/React.createElement("rect", {
  x: 134.137,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref93 = /*#__PURE__*/React.createElement("rect", {
  x: 95.0685,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref94 = /*#__PURE__*/React.createElement("rect", {
  x: 218.055,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref95 = /*#__PURE__*/React.createElement("rect", {
  x: 153.041,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref96 = /*#__PURE__*/React.createElement("rect", {
  x: 137.918,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref97 = /*#__PURE__*/React.createElement("rect", {
  x: 98.8494,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref98 = /*#__PURE__*/React.createElement("rect", {
  x: 221.836,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref99 = /*#__PURE__*/React.createElement("rect", {
  x: 156.822,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref100 = /*#__PURE__*/React.createElement("rect", {
  x: 141.699,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref101 = /*#__PURE__*/React.createElement("rect", {
  x: 101.37,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref102 = /*#__PURE__*/React.createElement("rect", {
  x: 224.356,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref103 = /*#__PURE__*/React.createElement("rect", {
  x: 159.343,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref104 = /*#__PURE__*/React.createElement("rect", {
  x: 144.219,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref105 = /*#__PURE__*/React.createElement("rect", {
  x: 115.233,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref106 = /*#__PURE__*/React.createElement("rect", {
  x: 238.219,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref107 = /*#__PURE__*/React.createElement("rect", {
  x: 173.206,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref108 = /*#__PURE__*/React.createElement("rect", {
  x: 117.753,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref109 = /*#__PURE__*/React.createElement("rect", {
  x: 240.74,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref110 = /*#__PURE__*/React.createElement("rect", {
  x: 175.726,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref111 = /*#__PURE__*/React.createElement("rect", {
  x: 74.9041,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref112 = /*#__PURE__*/React.createElement("rect", {
  x: 197.89,
  y: 142,
  width: 1.26042,
  height: 34,
  rx: 0.630208,
  fill: "#2E3545"
});

var _ref113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_ddd",
  x: 0.5,
  y: 0.5,
  width: 297,
  height: 242,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 19
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.282353 0 0 0 0 0.309804 0 0 0 0 0.372549 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.623529 0 0 0 0 0.670588 0 0 0 0 0.733333 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.745098 0 0 0 0 0.780392 0 0 0 0 0.839216 0 0 0 0.02 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow",
  result: "effect3_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect3_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_b",
  x: 40.4086,
  y: 69.4086,
  width: 94.1828,
  height: 31.1828,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 6.7957
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_b",
  x: 40.4086,
  y: 77.4086,
  width: 110.183,
  height: 31.1828,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 6.7957
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_b",
  x: 51.4086,
  y: 85.4086,
  width: 84.1828,
  height: 31.1828,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 6.7957
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_b",
  x: 51.4086,
  y: 93.4086,
  width: 93.1828,
  height: 31.1828,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 6.7957
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 121,
  y1: 83,
  x2: 54,
  y2: 83,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8DDEB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 137,
  y1: 91,
  x2: 54,
  y2: 91,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8DDEB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 122,
  y1: 99,
  x2: 65,
  y2: 99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8DDEB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 131,
  y1: 107,
  x2: 65,
  y2: 107,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EAEEF4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8DDEB"
})));

function SvgLoggiBarcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 243,
    viewBox: "0 0 298 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113);
}

var ForwardRef = React.forwardRef(SvgLoggiBarcode);
export default __webpack_public_path__ + "static/media/loggi-barcode.e7319495.svg";
export { ForwardRef as ReactComponent };